import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";

import RoleDashboard from "./components/dashboard/RoleDashboard";
import Wizard from "./components/RegistrationWizard/Wizard";
import ApproveList from "./components/dashboard/pending/ApproveList";
import ApproveDetail from "./components/dashboard/pending/ApproveDetail";
import MembersList from "./components/dashboard/members/MembersList";
import MemberDetail from "./components/dashboard/members/MemberDetail";
import Login from "./components/auth/Login";
import GroupNew from "./components/dashboard/groups/GroupNew";
import GroupsList from "./components/dashboard/groups/GroupsList";
import GroupDetail from "./components/dashboard/groups/GroupDetail";
import NewInterview from "./components/dashboard/interviews/NewInterview";
import NewIncident from "./components/dashboard/incidents/NewIncident";
import BlueBox from "./components/dashboard/bluebox/BlueBox";
import GroupAttendance from "./components/dashboard/attendance/GroupAttendance";
import GroupAttendanceMark from "./components/dashboard/attendance/GroupAttendanceMark";
import HouseAttendance from "./components/dashboard/attendance/HouseAttendance";
import AttendanceSummary from "./components/dashboard/attendance/AttendanceSummary";
import InterviewsSummary from "./components/dashboard/interviews/InterviewsSummary";
import MyInterviews from "./components/dashboard/interviews/MyInterviews";
import Statistics from "./components/dashboard/statistics/Statistics";
import IncidentsSummary from "./components/dashboard/incidents/IncidentsSummary";
import "./components/dashboard/api";

import "./components/dashboard/dashboard.css";
import "./components/RegistrationWizard/wizard.css";

function RequireAuth() {
  const token = localStorage.getItem("token");
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}


function RoutedApp() {
  const location = useLocation();
  return (
    <Routes key={location.key}>
      {/* Public */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Wizard />} />

      {/* Protected */}
      <Route element={<RequireAuth />}>
        <Route path="/dashboard" element={<RoleDashboard />} />

        {/* Admin/staff pages */}
        <Route path="/members/approve" element={<ApproveList />} />
        <Route path="/members/approve/:id" element={<ApproveDetail />} />
        <Route path="/members" element={<MembersList />} />
        <Route path="/members/:id" element={<MemberDetail />} />
        <Route path="/groups/new" element={<GroupNew />} />
        <Route path="/groups" element={<GroupsList />} />
        <Route path="/groups/:id" element={<GroupDetail />} />
        <Route path="/interviews/new" element={<NewInterview />} />
        <Route path="/interviews" element={<InterviewsSummary />} />
        <Route path="/interviews/mine" element={<MyInterviews />} />
        <Route path="/incidents/new" element={<NewIncident />} />
        <Route path="/bluebox" element={<BlueBox />} />
        <Route path="/attendance/group" element={<GroupAttendance />} />
        <Route path="/attendance/group/:id" element={<GroupAttendanceMark />} />
        <Route path="/attendance/house" element={<HouseAttendance />} />
        <Route path="/attendance/summary" element={<AttendanceSummary />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/incidents" element={<IncidentsSummary />} />
      </Route>

      {/* Default redirect */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Router>
      <RoutedApp />
    </Router>
  );
}